export const environment = {
  activeFile: "environment.webcomponent.ts",
  SITE_URL_LOCAL: "https://ppro.modernparking.net/portal/",
  BASE_URL_LOCAL: "https://ppro.modernparking.net/portal/invoices/api/",
  SITE_URL: "https://ppro.modernparking.net/portal/",
  BASE_URL: "https://ppro.modernparking.net/portal/invoices/api/",
  SITE_AUTH_HANDLER_URI: "",
  NODE_BASE_URL: "http://localhost:3000/",
  NODE_ENDPOINT_URL: "https://ppro.modernparking.net/api-node/",
  //Set for build mode:
  //serve - when using ng serve with full routing
  //web-component - when building as a web component
  buildMode: 'web-component',
  TRPC_ENDPOINT_URL: "https://ppro.modernparking.net/api-trpc",
  devTRPC_ENDPOINT_URL: "http://localhost:3000/api",
  version: require('../../package.json').version,
};
